import * as React from "react"
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MyLocation from './MyLocation';
import * as queryString from 'query-string';
import * as types from "../../constants/actionTypes";
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

/**
 * Container component for the E-Visit page.
 */
class InPerson extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isGeoAddressFetch: false
        };
        this.isFromVideoVisitPage = this.props && this.props.location && this.props.location.state && this.props.location.state.fromVideoVisitPage ? true : false;
    }

    componentDidMount() {
        const { isLoggedIn, userName, getUserAddress, cityAddress, stateAddress, latitude, longitude, isCurrentLocation, curPosLatitude, curPosLongitude, state, city } = this.props;
        if (this.isFromVideoVisitPage) { //if from videovisitoptions find a new doctor then just redirect to findcare with pcp search.
            let locationForVideoVisit = '';
            if (curPosLatitude && curPosLongitude && isCurrentLocation) {
                locationForVideoVisit = `${curPosLatitude},${curPosLongitude}`;
            } else if (cityAddress, stateAddress) {
                locationForVideoVisit = `${cityAddress},${stateAddress}`;
            } else if (state && city) {
                locationForVideoVisit = `${city},${state}`;
            }
            this.redirectToFindCareWithLocation(locationForVideoVisit);
        }

        if (isLoggedIn && userName && !latitude && !longitude && !curPosLatitude && !curPosLongitude) {
            getUserAddress(userName); //Getting User Address for urgent care.
            //console.log("hitting inperson did mount");
        } else {
            this.onLoadFindCare();
        }
        logUI("MBHWeb.UI.InPerson.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps) {
        const { isLoggedIn, userName, getUserAddress, latitude, longitude, curPosLatitude, curPosLongitude, cityAddress, stateAddress, waitingOnGeoAddress } = this.props;
        if (prevProps.userName !== userName && !latitude && !longitude && !curPosLatitude && !curPosLongitude) {
            if (isLoggedIn && userName) {
                getUserAddress(userName); //Getting User Address for urgent care.
            }
        }
        if (this.state.isGeoAddressFetch && !waitingOnGeoAddress) {
            const userlocation = ((cityAddress && stateAddress) ? `${cityAddress},${stateAddress}&isCurrentLocation=false` : `${latitude},${longitude}`);
            this.redirectToFindCareWithLocation(userlocation);
        }
    }

    onLoadFindCare() {
      //  e.preventDefault();
        const { latitude, longitude, curPosLatitude, curPosLongitude, getAddress, isCurrentLocation, cityAddress, stateAddress } = this.props;
        if (curPosLatitude && curPosLongitude && isCurrentLocation) {        
            this.redirectToFindCareWithLocation(`${curPosLatitude},${curPosLongitude}`);
        } else if (latitude && longitude) { 
            this.setState({ isGeoAddressFetch: true });
        } 
    }

    redirectToFindCareWithLocation(location) {        
        const newDoctorVideoVisitSearchquery = this.props && this.props.location && this.props.location.state && this.props.location.state.newDoctorSearchQuery;
        // Redirects to Find Care with location
        const userlocation = location ? `&location=${location}` : "";
        //console.log("hitting inperson redirect");
        this.props.history.push({
            pathname: '/findcare',
            state: { findNewDoctor: this.isFromVideoVisitPage ? true : false },
            searchParms: this.isFromVideoVisitPage ? `?${userlocation}` + (userlocation ? `&${newDoctorVideoVisitSearchquery}` : `${newDoctorVideoVisitSearchquery}`) : `?isUrgentCare=true${userlocation}&distance=25`
        });
    }

    render() {
        const { epicId, userAddresses, waitingOnGeoAddress } = this.props;
        const isFromVideoVisitPage = this.props && this.props.location && this.props.location.state && this.props.location.state.fromVideoVisitPage ? true : false;

        return (
            (this.props.fetchingUserAddress || waitingOnGeoAddress) ? <Spinner /> :
                <div id="in-person-landing" className="container-fluid body-content in-person-container">
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            {
                                <MyLocation userAddresses={userAddresses} history={this.props.history} isFromVideoVisitPage={isFromVideoVisitPage} />
                            }
                        </div>
                    </div>
                </div>
        );
    }
}

const mapStateToProps = (state) => {
    let userCity = "";
    let userState = "";
    if (!state.healthSource.fetchingUserAddress && state.healthSource.userAddress && state.healthSource.userAddress.length > 0) {
        userCity = state.healthSource.userAddress[0] ? state.healthSource.userAddress[0].City : userCity;
        userState = state.healthSource.userAddress[0] ? state.healthSource.userAddress[0].State : userState;
    }
    
    return {
        latitude: state.domain.lt,
        longitude: state.domain.ln,
        isCurrentLocation: state.locations.isCurrentLocation,
        curPosLatitude: state.locations.latitude,
        curPosLongitude: state.locations.longitude,
        userAddresses: state.healthSource.userAddress,
        fetchingUserAddress: state.healthSource.fetchingUserAddress,
        userName: state.sso.userDetails.userName,
        isLoggedIn: state.domain.li,
        epicId: state.domain.cu && state.domain.cu.eid ? state.domain.cu.eid : null,
        cityAddress: state.locations.city,
        stateAddress: state.locations.state,
        waitingOnGeoAddress: state.locations.waitingOnGeoAddress,
        geoAddressError: state.locations.geoAddressError,
        city: userCity,
        state: userState
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserAddress: (userName) => {
            dispatch({
                type: types.GET_USER_ADDRESS_START, userName: userName
            });
        },
        getAddress: (latitude, longitude) => {
            dispatch({
                type: types.GEOADDRESS, latitude: latitude, longitude: longitude
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InPerson);